import { NextPage } from 'next';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { RenterPage } from '@/components/route/referral/RenterPage';
import HeadMeta from '@/components/static-pages/HeadMeta';
import Loading from '@/components/switchback/Loading';
import { useRouter } from '@/hooks/useRouter';
import {
  selectAuthenticated,
  selectAuthenticating,
  selectHasTriedFetch,
} from '@/redux/modules/auth/selectors';
import { TRootState } from '@/redux/rootReducer';

const Renter: NextPage = () => {
  const intl = useIntl();
  const router = useRouter();

  const isAuthenticated = useSelector(selectAuthenticated);
  const isAuthenticating = useSelector<TRootState>(selectAuthenticating);
  const hasTriedFetch = useSelector(selectHasTriedFetch);

  useEffect(() => {
    if (!hasTriedFetch) return;
    if (!isAuthenticated && !isAuthenticating) {
      router.replace('/referral/join');
    }
  }, [isAuthenticated, isAuthenticating, hasTriedFetch, router]);

  // Do not show flash of renter page if user isn't logged in or if they are being logged in by the client.
  // If user never ends up being authenticated, they are redirected to the join page with the above effect.
  // The loading state here is for:
  //  1. User being logged in
  //  2. Waiting for page to redirect if they are logged out.
  if (!isAuthenticated || !hasTriedFetch) {
    return <Loading />;
  }

  return (
    <>
      <HeadMeta
        title={intl.formatMessage({
          defaultMessage: 'Referral Renter',
          id: 'NO15TI',
        })}
        noindex
      />

      <RenterPage />
    </>
  );
};

export default Renter;
